import { ExtendedButtonProps } from "@components/general/Button/Button";
import { Logo } from "@components/general/Logo";
import { useInteraction } from "@hooks/useInteraction";
import { ArrowDownIcon } from "@icons";
import { forwardRef } from "react";
import classNames from "classnames";
import styles from "./NavigationDropdownToggle.module.scss";

export const NavigationDropdownToggle = forwardRef<
    HTMLButtonElement,
    ExtendedButtonProps
>(({ onClick, className, children }, ref) => {
    const toggleClick = useInteraction(onClick);

    return (
        <button
            {...toggleClick}
            ref={ref}
            className={classNames(styles.toggle, className)}
        >
            <div className={styles.logoContainer}>
                <Logo className={styles.logo} variant="icon" />
            </div>

            <div className={styles.name}>
                {children}
                <ArrowDownIcon className={styles.arrow} />
            </div>
        </button>
    );
});
